import { render, staticRenderFns } from "./InputNote.vue?vue&type=template&id=4f2960a2&"
import script from "./InputNote.vue?vue&type=script&lang=js&"
export * from "./InputNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports